<div class="wrapper-footer-landing" [ngClass]="activeFooterClass">
  <div class="wrapper-content-footer-landing">
    <div class="footer-landing-left">
      <img src="../../../../assets/images/landing/logo-footer.svg" alt="logo moj rodjendan">
      <!--     TODO TRANSLATE       -->
<!--      <span>{{'FOOTER.everything_for_a_child_s_birthday_in_one_place' | translate}} <br> {{'FOOTER.click_by_click_birthday' | translate}}</span>-->
      <span>Sve za dečiji rođendan - na jednom mestu. <br>
Klik po klik - rođendan</span>
      <div class="store-footer">
        <a href="https://apps.apple.com/rs/app/moj-rodjendan/id6741870230" target="_blank"><img src="../../../../assets/images/landing/app-store.png" alt="app store"></a>
        <a href="https://play.google.com/store/apps/details?id=com.mojrodjendan.app" target="_blank"><img src="../../../../assets/images/landing/google-play-store.png" alt="google play"></a>
      </div>
    </div>
    <div class="footer-landing-right">
      <div class="links-pages">
        <h3>Linkovi</h3>
        <!--     TODO TRANSLATE       -->
<!--        <span [routerLink]="[PAGES_AND_PATHS.landingAboutUs.pagePath]" routerLinkActive="active">{{'GLOBAL.about_us' | translate}}</span>-->
        <span [routerLink]="[PAGES_AND_PATHS.landingAboutUs.pagePath]" routerLinkActive="active">O nama</span>
        <!--     TODO TRANSLATE       -->
<!--        <span [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" routerLinkActive="active">{{'GLOBAL.blog' | translate}}</span>-->
        <span [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" routerLinkActive="active">Blog</span>

        <!--     TODO TRANSLATE       -->
<!--        <span [routerLink]="[PAGES_AND_PATHS.landingForBusinesses.pagePath]" routerLinkActive="active">{{'GLOBAL.for_businesses' | translate}}</span>-->
        <span [routerLink]="[PAGES_AND_PATHS.landingForBusinesses.pagePath]" routerLinkActive="active">Za biznise</span>
        <!--     TODO TRANSLATE       -->
<!--        <span [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" routerLinkActive="active">{{'GLOBAL.contact' | translate}}</span>-->
        <span [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" routerLinkActive="active">Kontakt</span>
      </div>
      <div class="social-media">
        <!--     TODO TRANSLATE       -->
<!--        <h3>{{'FOOTER.social_networks' | translate}}</h3>-->
        <h3>Društvene mreže</h3>
        <div class="wrapper-social-media-box">
          <a href="https://www.instagram.com/mojrodjendan.rs/" target="_blank">
            <div class="social-media-box social-media-box--1">
              <img src="../../../../assets/icons/landing/icon_social03.svg" alt="instagram">
            </div>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61559882674234" target="_blank">
            <div class="social-media-box social-media-box--2">
              <img src="../../../../assets/icons/landing/icon_social04.svg" alt="facebook">
            </div>
          </a>
          <a href="https://www.youtube.com/@MojRodjendan" target="_blank">
            <div class="social-media-box social-media-box--3">
              <img src="../../../../assets/icons/landing/icon_social02.svg" alt="youtube">
            </div>
          </a>
          <a href="https://www.tiktok.com/@moj.rodjendan" target="_blank">
            <div class="social-media-box social-media-box--4">
              <img src="../../../../assets/icons/landing/icon_social01.svg" alt="tiktok">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper-links-footer-bottom">
    <!--     TODO TRANSLATE       -->
<!--    <span>{{'FOOTER.all_rights_reserved' | translate}}</span>-->
    <span>©2025 Moj Rođendan. All rights reserved</span>
    <div class="right-footer-bottom">
      <!--     TODO TRANSLATE       -->
<!--      <span [routerLink]="[PAGES_AND_PATHS.privacyPolicy.pagePath]">{{'FOOTER.privacy_policy' | translate}}</span>-->
      <span [routerLink]="[PAGES_AND_PATHS.privacyPolicy.pagePath]">Politika privatnosti</span>
      <!--     TODO TRANSLATE       -->
<!--      <span [routerLink]="[PAGES_AND_PATHS.termsOfUse.pagePath]">{{'FOOTER.terms_of_use' | translate}}</span>-->
      <span [routerLink]="[PAGES_AND_PATHS.termsOfUse.pagePath]">Uslovi korišćenja</span>|
    </div>
  </div>
</div>

